<template>
  <!-- ============================================================
       No.9 (B) 代行者権限付与：代行者ログイン後の TOP
       ※ 採択者宛のおしらせ（mst_notifications）は転載しない（報告内容に触れる通知が混ざるため）。
       ============================================================ -->
  <div class="AgentTop">
    <div class="contentsWidth mx-auto mt-5 mb-5">

      <!-- 代行対象の明示（誰の代行としてログインしているか） -->
      <div class="principalBox px-4 py-3 mb-4">
        <div class="principalName">
          <span class="bold">{{ principal.applicantName }}</span> 様の代行者としてログインしています
        </div>
        <div class="principalSub mt-1">
          代行者：{{ principal.agentName }}<span v-if="principal.allowedTo"> ／ ログイン期限：{{ principal.allowedTo }} まで</span>
        </div>
      </div>

      <!-- 採択者手続き -->
      <div class="mb-5">
        <div class="sectionTitle">採択者手続き</div>
        <b-table striped hover
          table-class="agentTopTable"
          thead-class="tableHead"
          :items="reports"
          :fields="header"
          show-empty>
          <template v-slot:empty>
            <div class="flex flexCenter">現在、入力できる手続きはありません。</div>
          </template>
          <template v-slot:cell(name)="row">
            <b-link @click="openForm(row.item)">{{ row.item.name }}</b-link>
          </template>
          <template v-slot:cell(term)="row">
            <span v-if="row.item.accepting">{{ row.item.term }}</span>
            <span v-else class="text-muted">{{ row.item.term }}（期間外）</span>
          </template>
          <!-- No.7 Phase N：到達可否は accepting のまま。ラベルだけ入力可否（adoptionOnTime）で
               切り替える＝採択者手続き期間外は開いても閲覧のみなので「確認する」と出す。 -->
          <template v-slot:cell(actions)="row">
            <b-button size="sm" variant="primary" class="bold"
              :disabled="!row.item.accepting"
              @click="openForm(row.item)">{{ row.item.adoptionOnTime ? '入力する' : '確認する' }}</b-button>
          </template>
        </b-table>
        <p class="text-muted small mt-2 mb-0">
          ※入力できるのは「寄付申込書」「間接経費免除申請書」「書類送付先住所」「その他添付」です。
          報告書の内容・申請内容は表示されません。
        </p>
      </div>

      <!-- 問合せ -->
      <div class="mb-5">
        <div class="sectionTitle">問合せ</div>
        <p class="mb-2">手続きについてのご質問は、こちらから事務局へお問い合わせいただけます。</p>
        <b-button variant="primary" class="bold" @click="openInquiry">問合せ一覧へ</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api';

export default {
  name: 'agentTop',
  data() {
    return {
      header: [
        { key: 'name', label: '助成種別', thStyle: { width: '280px' } },
        { key: 'year', label: '年度', thStyle: { width: '80px' } },
        // 手続き期間は「YYYY年MM月DD日 HH時 ～ …」で長いため折り返さない幅を確保する
        { key: 'term', label: '手続き期間', tdClass: 'termCell' },
        { key: 'actions', label: '', thStyle: { width: '120px' } },
      ],
      principal: { applicantName: '', agentName: '', allowedTo: '' },
      reports: [],
    };
  },
  async created() {
    this.$store.dispatch('page/onLoading');
    const res = await api.all([
      api.send('/api/agent/context'),
      api.send('/api/agent/reportType/mylist'),
    ]).catch(() => false);
    if (res !== false) {
      const c = res[0].data;
      this.principal = {
        applicantName: c.applicantName,
        agentName: c.agentName,
        // 無期限（9999...）は表示しない
        allowedTo: c.allowedTo && String(c.allowedTo).indexOf('9999') !== 0
          ? String(c.allowedTo).substr(0, 10).replace(/-/g, '/') : '',
      };
      this.reports = res[1].data.list || [];
    }
    this.$store.dispatch('page/offLoading');
  },
  methods: {
    openForm(item) {
      if (!item.accepting) {
        return;
      }
      this.$router.push({ name: 'agentReportForm', params: { reptypeId: item.typeId } });
    },
    openInquiry() {
      this.$router.push({ name: 'agentInquiryList' });
    },
  },
};
</script>

<style scoped>
.principalBox {
  background: #F4FAFB;
  border: 1px solid #D5EAF0;
  border-radius: 6px;
}
.principalName {
  font-size: 18px;
  color: #333;
}
.principalSub {
  font-size: 13px;
  color: #555;
}
.AgentTop /deep/ .termCell {
  white-space: nowrap;
}
.sectionTitle {
  font-size: 18px;
  color: #333;
  /* 既存の下線（style.css の hr.title＝#A0A9D0 / 2px）と同じ色・太さにそろえる */
  border-bottom: solid 2px #A0A9D0;
  padding-bottom: 6px;
  margin-bottom: 12px;
}
</style>
